let popup;
let dismissTimeout;
const triggers = {};

function getPopupSettings() {
  // set how long after the popup has been dismissed before it can be shown again to the user
  dismissTimeout = popup.hasAttribute('dismiss-timeout')
    ? parseInt(popup.getAttribute('dismiss-timeout')) * 1000
    : 0;

  if (popup.hasAttribute('trigger-time')) {
    // millisecond delay to trigger
    triggers.timeout = parseInt(popup.getAttribute('trigger-time')) * 1000;
  }
  if (popup.hasAttribute('trigger-scroll')) {
    // show popup based on scroll behaviour
    triggers.scroll = true;
    // page scroll percentage for trigger
    triggers.scroll_depth = parseInt(popup.getAttribute('trigger-scroll'));
  }
  if (popup.hasAttribute('trigger-scrollup')) {
    // show popup based on scroll behaviour
    triggers.scroll = true;
    // scroll up to trigger
    triggers.scroll_up = true;
  }
  if (popup.hasAttribute('trigger-mouseout')) {
    // show popup when the mouse leaves the window
    triggers.mouse_out = true;
  }
}

function setupTriggers() {
  timeTrigger();
  scrollTrigger();
  exitTrigger();
}

function showPopup() {
  if (isDismissed()) return;
  popup.classList.add('c-community-popup--active');
}

function cannotTriggerPopup(trigger) {
  return !triggers[trigger] || isDismissed();
}

function isDismissed() {
  // if no item, then it hasn't been dismissed
  const expiryString = localStorage.getItem('communityPopupDismissed');
  if (!expiryString) {
    return false;
  }

  // if we have issues retrieving the data, clear the data and say it hasn't been dismissed
  let expiry;
  try {
    expiry = parseInt(expiryString);
  } catch (e) {
    localStorage.removeItem('communityPopupDismissed');
    return false;
  }

  // if it expired before now, then clear item and say it hasn't been dismissed
  const now = new Date();
  if (now.getTime() > expiry) {
    localStorage.removeItem('communityPopupDismissed');
    return false;
  }

  // otherwise it must have been dismissed recently
  return true;
}

function setDismissed() {
  const now = new Date();
  const expiry = now.getTime() + dismissTimeout;
  // set a time for when this popup can show again
  localStorage.setItem('communityPopupDismissed', expiry.toString());
}

function timeTrigger() {
  if (cannotTriggerPopup('timeout')) return;

  setTimeout(() => {
    showPopup();
  }, triggers.timeout);
}

function scrollTrigger() {
  if (cannotTriggerPopup('scroll')) return;

  let last_scroll = 0;

  setTimeout(() => {
    window.addEventListener(
      'scroll',
      throttle(() => {
        if (isDismissed()) return;

        const scrolled = window.scrollY;
        const document_height = document.documentElement.scrollHeight;
        const screen_height = window.outerHeight;
        const scroll_percent =
          (scrolled / (document_height - screen_height)) * 100;

        if (
          (triggers.scroll_depth && scroll_percent >= triggers.scroll_depth) ||
          (triggers.scroll_up && scroll_percent < last_scroll)
        ) {
          showPopup();
        }
        last_scroll = scroll_percent;
      }, 200),
    );
  });
}

function exitTrigger() {
  if (cannotTriggerPopup('mouse_out')) return;

  document.addEventListener('mouseleave', function () {
    showPopup();
  });
}

function setupEventListeners() {
  const open = popup.querySelector('[data-popup="open"]');
  const close = popup.querySelector('[data-popup="close"]');

  open &&
    open.addEventListener('click', () => {
      setDismissed();
      popup.classList.remove('c-community-popup--active');
    });

  close &&
    close.addEventListener('click', () => {
      setDismissed();
      popup.classList.remove('c-community-popup--active');
    });
}

function throttle(func, timeFrame) {
  let lastTime = 0;
  return function () {
    const now = new Date();
    if (now - lastTime >= timeFrame) {
      func();
      lastTime = now;
    }
  };
}

export const communityPopup = () => {
  popup = document.querySelector('[data-popup="community"]');

  if (!popup) return;
  getPopupSettings();
  setupTriggers();
  setupEventListeners();
};
